import { observable } from 'mobx';
import { MonografiaModel } from '../Monografia';
import { TipoProfessor } from '../Professor';

export class MembroDaBancaModel {
  @observable public monografiaId: number = 0;
  @observable public monografia: MonografiaModel = new MonografiaModel();
  @observable public membroId: number = 0;
  @observable public membro: MembroModel = new MembroModel();
  @observable public suplente: boolean = false;
  @observable public ordemParaConvite: number = 0;
  @observable public conviteEnviado: boolean = false;
  @observable public conviteAceito?: boolean;
  @observable public dataDaResposta?: Date;
}

export class MembroModel {
  @observable public id: number = 0;
  @observable public nome: string = '';
  @observable public cpf: string = '';
  @observable public telefone: string = '';
  @observable public vagasPreProjeto: number = 0;
  @observable public email: string = '';
  @observable public tipo: TipoProfessor = TipoProfessor.Titular;
  @observable public ativo: boolean = true;
  @observable public ativoBanca: boolean = true;
}
